import { api } from "./api";

const CHUNK = 4 * 1024 * 1024;

/** Sube un archivo por partes (4 MB) y crea el material. onProgress recibe 0-100. */
export async function uploadMaterial(file, { title, description }, onProgress) {
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  const { data: init } = await api.post("/marketing/uploads/init", { filename: file.name, size: file.size, total_chunks: total });
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK));
    await api.post(`/marketing/uploads/${init.upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.round(((i + 1) / total) * 95));
  }
  const { data } = await api.post(`/marketing/uploads/${init.upload_id}/complete`, { title, description });
  onProgress?.(100);
  return data;
}
